module.exports = __webpack_public_path__ + "static/img/icon-favourite.c4c4311.png";